var map = {
	"./balancer/index.ts": "09e9",
	"./contract-call/index.ts": "070e",
	"./cream-swap/index.ts": "2c8e",
	"./erc20-balance-of-coeff/index.ts": "c308",
	"./erc20-balance-of-cv/index.ts": "f3ec",
	"./erc20-balance-of-fixed-total/index.ts": "d71a",
	"./erc20-balance-of/index.ts": "9d58",
	"./erc20-with-balance/index.ts": "bc48",
	"./eth-balance/index.ts": "ecf8",
	"./index.ts": "f5d2",
	"./maker-ds-chief/index.ts": "ca26",
	"./moloch/index.ts": "88bd",
	"./pancake/index.ts": "90eb",
	"./synthetix/index.ts": "84ae",
	"./uni/index.ts": "9d75",
	"./wan-vote/index.ts": "1156",
	"./yearn-vault/index.ts": "a790"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6407";